'use client'

import { ClosestSiteText } from '@components/app/ClosestSiteText'
import { GeolocationContext } from '@components/hooks/GeolocationProvider/index.client'
import { ReviewBox } from '@components/primitives/ReviewBox'
import { getSortedLocations } from '@modules/trials/helpers/parseLocationsFromTrial/parseTruncatedLocationsFromTrial'
import type { TrialLocationNarrow } from '@modules/trials/types/TrialAssociatedWithLocations'
import { useContext, useEffect, useState } from 'react'
import { FacilityPhotoCollage } from './FacilityPhotoCollage'

export const ClosestLocation = ({
  trialLocations,
}: {
  trialLocations: TrialLocationNarrow[]
}) => {
  const userLocation = useContext(GeolocationContext)
  const [closestSite, setClosestSite] = useState<TrialLocationNarrow>()

  useEffect(() => {
    const [site] = getSortedLocations(trialLocations, userLocation)
    setClosestSite(site)
  }, [trialLocations, userLocation])

  if (!closestSite) {
    return null
  }

  const firstValidReview = closestSite.facilityJoin?.reviews.find(
    (review) => review.rating > 3 && review.pickedReviewText,
  )

  const reviewText = firstValidReview?.pickedReviewText
  const ratingValue = firstValidReview?.rating ?? 0

  const displayReview = ratingValue > 3 && !!reviewText

  return (
    <div className='mb-2 flex flex-col space-y-2'>
      <ClosestSiteText
        closestSite={closestSite}
        includeDistance={true}
        userLocation={userLocation}
      />
      {displayReview && (
        <ReviewBox ratingValue={ratingValue} reviewText={reviewText} />
      )}
      <FacilityPhotoCollage closestSite={closestSite} />
    </div>
  )
}
